// @flow
import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { refreshAccounts } from 'data/accounts/actions';

import { createDialog } from 'data/rootUi/actions';
import { mkRootUiData } from 'data/rootUi/types';

import { createPromiseAction } from 'utils/actionHelpers';

import {
  DIALOG_TYPE as DIALOG_ACCOUNT_DISCOVERY,
  DIALOG_TYPE as DIALOG_ACCOUNTS_DISCOVERY,
  mkAccountDiscoveryDialogProps,
} from './types';

export const accountDiscoverySetup = createAction( 'ACCOUNT_DISCOVERY_SETUP' );
export const accountDiscoveryReset = createAction( 'ACCOUNT_DISCOVERY_RESET' );
export const accountDiscoveryResetToCredentialState = createAction('ACCOUNT_DISCOVERY_RESET_TO_CREDENTIALS_STATE');

export const institutionSelected = createAction('ACCOUNT_DISCOVERY_INSTITUTION_SELECTED');

export const accountDiscoveryCredentialsFormSubmit = createPromiseAction('ACCOUNT_DISCOVERY_CREDENTIALS_FORM_SUBMIT');
export const accountDiscoveryCredentialsFormSubmitResponse = createAction('ACCOUNT_DISCOVERY_CREDENTIALS_FORM_SUBMIT_SUCCESS');

export const accountDiscoveryStatus = createAction('ACCOUNT_DISCOVERY_STATUS');

export const accountDiscoveryMfaRequired = createAction('ACCOUNT_DISCOVERY_MFA_REQUIRED');
export const accountDiscoveryMfaFormSubmit = createPromiseAction('ACCOUNT_DISCOVERY_MFA_FORM_SUBMIT');
export const accountDiscoveryMfaFormSubmitResponse = createAction('ACCOUNT_DISCOVERY_MFA_FORM_SUBMIT_RESPONSE');

export const getPartnerAuthUris = createAction('GET_PARTNER_AUTH_URIS');
export const getPartnerAuthUrisSuccess = createAction('GET_PARTNER_AUTH_URIS_SUCCESS');
export const getPartnerAuthUrisFailure = createAction('GET_PARTNER_AUTH_URIS_FAILURE');

export const getPlaidPublicToken = createAction('GET_PLAID_PUBLIC_TOKEN');
export const getPlaidPublicTokenResponse = createAction('GET_PLAID_PUBLIC_TOKEN_RESPONSE');

export const accountDiscoverySuccessWithAccounts = createAction('ACCOUNT_DISCOVERY_SUCCESS_WITH_ACCOUNTS');
export const accountDiscoverySuccess = createAction('ACCOUNT_DISCOVERY_SUCCESS');

export const accountDiscoveryFailure = createAction('ACCOUNT_DISCOVERY_FAILURE');
export const accountDiscoveryStopped = createAction('ACCOUNT_DISCOVERY_STOPPED');
export const accountDiscoveryError = createAction('ACCOUNT_DISCOVERY_ERROR');

export const discoverInstitutionLoginWithAccounts = createAction('DISCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS');
export const discoverInstitutionLoginWithAccountsResponse = createAction('DISCCOVER_INSTITUTION_LOGIN_WITH_ACCOUNTS_RESPONSE');

export const rediscoverInstitutionLogin = createAction("REDISCOVER_INSTIUTION_LOGIN");
export const rediscoverInstitutionLoginResponse = createAction("REDISCOVER_INSTIUTION_LOGIN_RESPONSE");

export const accountDiscoveryPlaidItemUpdateSuccess = createAction('ACCOUNT_DISCOVERY_PLAID_ITEM_UPDATE_SUCCESS');

export const logPlaidItemEvent = createAction('ACCOUNT_DISCOVERY_LOG_PLAID_ITEM_EVENT');
export const logPlaidItemEventResponse = createAction('ACCOUNT_DISCOVERY_LOG_PLAID_ITEM_EVENT_RESPONSE');

export const doAccountDiscovery = createAction(
  createDialog,
  (options = {}) => mkRootUiData({
    type: DIALOG_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      initiator: options.initiator || 'unknown',
      mode: options.mode || 'ADD-FI',
    })),
  })
);

export const doAccountRediscovery = createAction(
  createDialog,
  (institutionLogin, options = {}) => mkRootUiData({
    type: DIALOG_ACCOUNT_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      initiator: options.initiator || 'unknown',
      mode: 'ACCOUNT-REDISCOVERY',
      institutionLogin,

      afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
  })
);

export const doProvideCredentialsAndRefresh = createAction(
  createDialog,
  (institutionLogin, options = {}) => mkRootUiData({
    id: institutionLogin.id,
    type: DIALOG_ACCOUNTS_DISCOVERY,
    allowNesting: false,
    props: ImmutableMap(mkAccountDiscoveryDialogProps({
      initiator: options.initiator || 'unknown',
      mode: 'PROVIDE-CREDENTIALS',
      institutionLogin,

      afterCloseAction: refreshAccounts({ institutionLoginId: institutionLogin.id }),
    })),
  })
);

